import { get, isFunction } from '@elliemae/ds-utilities/utils';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import { addFilterToColumn } from './addFilterToColumn.js';
import filterRowsByQuery, { filterRowsByQueryGroup } from './filtering-helper/filterRowsByQuery.js';
import { useFilterableState } from './useFilterableState.js';
import '@babel/runtime/helpers/esm/defineProperty';
import 'react';
import '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import './filterableFormatter.js';
import './components/FilterableHeader.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'prop-types';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '@elliemae/ds-system/theme';
import './components/filterable-menus/getFilterMenuByType.js';
import './components/filterable-menus/DateRangeFilterMenu.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import '@elliemae/ds-basic/Button';
import 'moment';
import './components/filterable-menus/defaultDateFormat.js';
import './components/filterable-menus/SingleDateFilterMenu.js';
import './components/filterable-menus/SingleRangeSwitcherMenu.js';
import './components/filterable-menus/TextFilterMenu.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';
import './helper.js';
import './filtering-helper/strategiesOperators.js';
import 'comparejs';
import 'uuid';

/* eslint-disable indent */

var decorateColumn = function decorateColumn(column, grid) {
  var _grid$props = grid.props,
      _grid$props$isFiltera = _grid$props.isFilterableColumnActive,
      isFilterableColumnActive = _grid$props$isFiltera === void 0 ? function (col) {
    return col.searchable;
  } : _grid$props$isFiltera,
      onRemoveAllFilters = _grid$props.onRemoveAllFilters,
      _grid$actions = grid.actions,
      addFilter = _grid$actions.addFilter,
      removeFilter = _grid$actions.removeFilter,
      _grid$state = grid.state,
      query = _grid$state.query,
      filters = _grid$state.filters;
  return isFilterableColumnActive(column) ? addFilterToColumn({
    grid: grid,
    onAddFilter: addFilter,
    onRemoveFilter: removeFilter,
    onRemoveAllFilters: onRemoveAllFilters,
    query: query,
    filters: filters
  }, column) : column;
};

var composeRows = function composeRows(rows, grid) {
  var _grid$getInstance = grid.getInstance(),
      _grid$getInstance$pro = _grid$getInstance.props,
      isDataFiltered = _grid$getInstance$pro.isDataFiltered,
      groupedRows = _grid$getInstance$pro.groupedRows,
      query = _grid$getInstance.state.query,
      composedRows = _grid$getInstance.composedRows;

  var nextRows = !groupedRows ? filterRowsByQuery(rows, query) : filterRowsByQueryGroup(rows, query, composedRows);
  return !isDataFiltered ? nextRows : rows;
};

var FilterablePlugin = createInstancePlugin('filterable', {
  registerStateHook: useFilterableState,
  decorateColumn: decorateColumn,
  composeRows: composeRows,
  registerHotKeys: function registerHotKeys(grid) {
    return {
      key: 'ctrl+f',
      handler: function handler(_ref) {
        var cellIndex = _ref.cellIndex;

        var _grid$getInstance2 = grid.getInstance(),
            decoratedColumns = _grid$getInstance2.decoratedColumns;

        var column = decoratedColumns[cellIndex];
        var toggleMenuMethod = get(column, ['filterMenu', 'current', 'toggleMenu']);
        if (isFunction(toggleMenuMethod)) toggleMenuMethod();
      }
    };
  }
});

export { FilterablePlugin };
//# sourceMappingURL=FilterablePlugin.js.map
